import {useCallback} from 'react';

import {useDocumentRepository} from '@/components/document/repository';
import {useDocumentUtils} from '@/components/document/utils';
import {INITIAL_SECTION} from '@/constants/sections';
import {DocumentModel} from '@/engine/types/document-model/document-model';
import {getAllAttachmentIds} from '@/utils/document/attachments';
import {DocumentContextType} from '../document-context';

type Props = {
  documentModel: DocumentModel;
  setCurrentSectionId: DocumentContextType['setCurrentSectionId'];
};

export const useResetCompleteForm = ({documentModel, setCurrentSectionId}: Props) => {
  const {store} = useDocumentUtils();
  const {removeDocumentAttachment} = useDocumentRepository();

  return useCallback(async () => {
    const state = store.getState();
    state.clearForm(documentModel);
    state.unregisterAttachments();

    const attachmentIds = getAllAttachmentIds(state.attachments);
    await Promise.all(attachmentIds.map(attachmentId => removeDocumentAttachment(attachmentId)));

    setCurrentSectionId(INITIAL_SECTION);
  }, [store, documentModel, setCurrentSectionId, removeDocumentAttachment]);
};
